import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface TreeViewProps extends KendoWidgetProps, kendo.ui.TreeViewOptions {
    children?: React.ReactNode;
}

export default class TreeView extends KendoBaseComponent<TreeViewProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.TreeView(domNode as Element, (props as kendo.ui.TreeViewOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;
            const widget = (this.widgetInstance as kendo.ui.TreeView);

            if (props.dataSource && props.dataSource === widget.options.dataSource) {
                delete props.dataSource;
            }
            this.widgetInstance.setOptions(props);
        }
        return (
            <ul ref={this.elementRef}>
                {this.props.children}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-react-wrapper/src/treeview/index.tsx